// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3iU2-"};